export const EM_FILA = 0;
export const PROCESSAMENTO = 1;
export const PROCESSADO_COM_SUCESSO = 2;
export const PROCESSADO_COM_ERRO = 3;
export const AGUARDANDO_APROVACAO = 4;
export const RESULTADO_INDETERMINADO = 5;

const LABELS_ESTADO = {
    AGUARDANDO_APROVACAO: "AGUARDANDO APROVAÇÃO",
    EM_FILA: "EM FILA",
    PROCESSAMENTO: "PROCESSAMENTO",
    PROCESSADO_COM_SUCESSO: "PROCESSADO COM SUCESSO",
    PROCESSADO_COM_ERRO: "PROCESSADO COM ERRO",
    RESULTADO_INDETERMINADO: "RESULTADO INDETERMINADO"
};

export function getLabelEstado(estado) {
    if (!estado) {
        return "";
    }

    return LABELS_ESTADO[estado] || `${estado}`.replaceAll("_", " ");
}
